export default "__VITE_ASSET__BA_Jvh6o__"